import { OnEventDispatcher } from "../../core/on-event-dispatcher";
import { Application } from "../../main";
const open_svg:string = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>`;
const close_svg:string = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>`;
export class MenuButton extends OnEventDispatcher {
    elm: JQuery<HTMLElement>;
    constructor(container:JQuery<HTMLElement>) {
        super();

        this.elm = $(`<div class='menu-button'>
            <div class='menu-button-inner'>
                <div class='open'>
                    <img src='static/icon_hamburger_lines.svg' />
                </div>
                <div class='close'>
                    <img src='static/icon_hamburger_close.svg' />
                </div>
            </div>
        </div>`).appendTo(container);

        this.elm.on("click", () => {
            Application.menuView.toggle();
        });
    }
}